export const actionIdMapping: any = {
  staging: {
    End_to_end_sync: 196,
    Fetcher: 190,
    Unifier: 177,
    business_advisor: 229,
    unifier_business_advisor: 283,
  },
  production: {
    End_to_end_sync: 100,
    Fetcher: 97,
    Unifier: 90,
    business_advisor: 126,
    unifier_business_advisor: 150,
  },
};
export const APPLICABLE_INDUSTRY_IDS = [21, 22];
export const INDUSTRY_UNIFIER_TABLE_IDS = [5];
export const INDUSTRY_ADVISOR_TABLE_IDS = [4];
